import * as types from './types';

export function setInterlinkC2CData(id, data) {
    return {
        meta: {
            id,
        },
        payload: data,
        type: types.SET_INTERLINK_DATA,
    };
}

export function setInterlinkHomepageData(data, locale) {
    return {
        meta: {
            id: `homepage-${locale}`,
        },
        payload: data,
        type: types.SET_INTERLINK_DATA,
    };
}
